export default __webpack_public_path__ + "static/media/djb.b88d61b4.png";